import { render, staticRenderFns } from "./MenuPsychologist.vue?vue&type=template&id=7fe233cd&"
import script from "./MenuPsychologist.vue?vue&type=script&lang=js&"
export * from "./MenuPsychologist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports